import { Spinner } from '@fluentui/react-components';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { getAuthFromQueryClient } from '../lib/auth/hooks';
import { isOrgScopedRole } from '../lib/auth/roles';

const ServiceRequestsPage = lazy(() =>
  import('../pages/service-requests/ServiceRequestsPage').then((m) => ({
    default: m.ServiceRequestsPage,
  })),
);

export const Route = createFileRoute('/service-requests')({
  beforeLoad: async ({ context }) => {
    const auth = await getAuthFromQueryClient(context.queryClient);

    // Not authenticated - redirect to login
    if (!auth?.user) {
      throw redirect({
        to: '/login',
        search: { redirectTo: '/service-requests' },
      });
    }

    // Check role
    const ALLOWED_ROLES = ['admin', 'user', 'org-admin'] as const;
    if (!ALLOWED_ROLES.includes(auth.user.role as (typeof ALLOWED_ROLES)[number])) {
      throw redirect({ to: '/unauthorized' });
    }

    // Regular users must have an active organization
    if (isOrgScopedRole(auth.user.role) && !auth.session?.activeOrganizationId) {
      throw redirect({ to: '/settings/switch-organization' });
    }
  },
  component: () => (
    <Suspense
      fallback={
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          <Spinner />
        </div>
      }
    >
      <ServiceRequestsPage />
    </Suspense>
  ),
});
